export default __webpack_public_path__ + "static/media/validity_white.722b5452.png";